module.exports = __webpack_public_path__ + "assets/img/tedian7.eae54937.png";